import { render, staticRenderFns } from "./CBusinessCardUp.vue?vue&type=template&id=1da3c730&scoped=true"
import script from "./CBusinessCardUp.vue?vue&type=script&lang=js"
export * from "./CBusinessCardUp.vue?vue&type=script&lang=js"
import style0 from "./CBusinessCardUp.vue?vue&type=style&index=0&id=1da3c730&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da3c730",
  null
  
)

export default component.exports